import {
  ArrowRightIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useNavigate } from "react-router-dom"

const SettingsHeader = () => {
  const navigate = useNavigate()

  const onBack = () => {
    navigate("/")
  }

  return (
    <FlexBox
      direction="row"
      align="center"
      gap={SPACING.space4}
      style={{
        padding: `${SPACING.space4} ${SPACING.space6}`,
        borderBottom: `1px solid ${JoonUIColor.border.default}`,
      }}
    >
      <button style={{ transform: "rotate(180deg)" }} onClick={onBack}>
        <ArrowRightIcon size={24} color={JoonUIColor.text.primary} />
      </button>
      <Typography variant="h2">Settings</Typography>
    </FlexBox>
  )
}
export default SettingsHeader
